import { useSelector, useDispatch } from "react-redux";
import Modal from "../../../../components/Modal";
import { EDIT_FAVOURITES_VIEW, WARNING_VIEW } from "../../../../constants";
import styles from "./Warning.module.scss";
import AttentionIcon from "../../../../assets/icons/attention_icon.svg";
import FilterHeaderButton from "../../../../layouts/Filter/components/FilterHeaderButton";
import {
  SELECT_FAVOURITE,
  SET_ACTIVE_VIEW,
  SET_WARNING,
} from "../../../../constants/actions";

const createWarningContent = (dispatch, previousView = "") =>
  new Map([
    [
      "UNSAVED",
      {
        heading: "One sec there, mate",
        message:
          "Looks like you have unsaved changes. Are you sure you want to continue and lose your progress?",
        buttons: [
          {
            label: "Go back",
            onClick: () => {
              dispatch({ type: SET_WARNING, payload: "" });
              dispatch({
                type: SET_ACTIVE_VIEW,
                payload: EDIT_FAVOURITES_VIEW,
              });
            },
          },
          {
            label: "Continue",
            onClick: () => {
              dispatch({ type: "CLEAR_ALL_FAVOURITES_SELECTIONS" });
              dispatch({ type: SELECT_FAVOURITE, payload: "" });
              dispatch({ type: SET_ACTIVE_VIEW, payload: previousView });
            },
          },
        ],
      },
    ],
    [
      "LOGIN",
      {
        heading: "One sec there, mate",
        message: "You need to be logged in to select favourites.",
        buttons: [
          {
            label: "Ok",
            onClick: () => {
              dispatch({ type: SET_WARNING, payload: "" });
              dispatch({ type: SET_ACTIVE_VIEW, payload: previousView });
            },
          },
        ],
      },
    ],
  ]);

export function Warning() {
  const dispatch = useDispatch();
  const { activeView, previousView } = useSelector((state) => state.view);
  const { warning } = useSelector((state) => state.favourites);

  const content =
    createWarningContent(dispatch, previousView).get(warning) ||
    createWarningContent(dispatch, previousView).get("UNSAVED");

  if (activeView !== WARNING_VIEW) return null;

  return (
    <Modal variant={WARNING_VIEW}>
      <div className={styles.warning}>
        <div className={styles.warning_content}>
          <div className={styles.warning_icon}>
            <img src={AttentionIcon} alt="Attention" />
          </div>
          <div className={styles.warning_content_text}>
            <h3>{content.heading}</h3>
            <p>{content.message}</p>
          </div>
          <div className={styles.warning_buttons}>
            {content.buttons.map((button) => (
              <FilterHeaderButton
                key={button.label}
                name={button.label}
                onClick={button.onClick}
              />
            ))}
          </div>
        </div>
        <div className={styles.warning_bg} />
      </div>
    </Modal>
  );
}
